// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__11nmm","body":"App_body__AORCg","menu":"App_menu__4SkGD","help":"App_help__VPcJd","mobile":"App_mobile__I9NKY"};